export const API_GET_LIST_CATEGORY = "api/product_category/site/list";
export const API_DELETE_CATEGORY = "api/product_category/form/delete";
export const API_UPDATED_CATEGORY = "api/product_category/form/update";
export const API_CREATED_CATEGORY = "api/product_category/form/create";
export const API_VIEW_CATEGORY = "api/product_category/site/detail";